module.exports = __webpack_public_path__ + "img/icon_recharge_card.4cfc7673.png";